var SEE_ALL_SOLUTIONS = 'See all free services and solutions';
var SUB_TITLE = 'Enhance your cloud infrastructure with tools and solutions tailored for Azure, from security and monitoring to development and analytics.';
var azureProducts = [
    {
        title: 'Virtual Machine images',
        icon: 'VirtualMachine',
        description: 'Ready-to-deploy VM images with pre-configured OS, software, and settings to streamline your Azure VM setup, saving time and effort.',
        navigateOptions: {
            type: 'App',
            query: {
                product: 'virtual-machines'
            }
        }
    },
    {
        title: 'Containers (Kubernetes Apps)',
        icon: 'KubernetesServices',
        description: 'Accelerate deployment with pre-packaged solutions, ensuring scalability and efficiency for your projects.',
        navigateOptions: {
            type: 'App',
            query: {
                product: 'containers'
            }
        }
    },
    {
        title: 'Azure applications (Solution Templates)',
        icon: 'AppServices',
        description: 'Deploy complex solutions swiftly with pre-configured packages, covering everything from VMs to databases, for streamlined setup.',
        navigateOptions: {
            type: 'App',
            query: {
                product: 'azure-applications'
            }
        }
    },
    {
        title: 'Microsoft Azure services',
        icon: 'AzureFill',
        description: "Elevate your cloud with Azure's first-party services, including AI apps & agents, Machine Learning, Storage, and Databases, for seamless integration and scalability.",
        navigateOptions: {
            type: 'App',
            query: {
                product: 'azure-services'
            }
        }
    },
    {
        description: 'Optimize your Azure environment with expert-led managed services, ensuring top performance and security while reducing operational load.',
        title: 'Managed Services',
        navigateOptions: {
            type: 'App',
            query: {
                product: 'managed-services'
            }
        },
        icon: 'ManagedService'
    }
];

export { SEE_ALL_SOLUTIONS, SUB_TITLE, azureProducts };
